export const breadcrumb = {
  stats: {
    title: 'Статистика',
    general: 'Общая',
    detailed: 'Подробная'
  }
};
